/* unplugin-vue-components disabled */import { render } from "./DashboardSpeachesTab.vue?vue&type=template&id=122bb6ff&scoped=true&ts=true"
import script from "./DashboardSpeachesTab.vue?vue&type=script&lang=ts"
export * from "./DashboardSpeachesTab.vue?vue&type=script&lang=ts"

import "./DashboardSpeachesTab.vue?vue&type=style&index=0&id=122bb6ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122bb6ff"]])

export default __exports__